module.exports = __webpack_public_path__ + "img/face_auth_type_4.707dc719.png";